import styled from "styled-components";
import { Spinner } from "ui/core";

const Loading = () => {
  return (
    <Layout>
      <Spinner size={60} />
    </Layout>
  );
};

const Layout = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export default Loading;
